import React from "react"

export const GraduationIcon = ({ size = 25 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 25 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='m13.224 4.054 9.498 5.519c.37.215.37.747 0 .962l-9.498 5.519c-.584.34-1.304.34-1.887 0L1.84 10.535a.556.556 0 0 1 0-.962l9.497-5.519a1.88 1.88 0 0 1 1.887 0'
        fill='currentColor'
      />
      <path
        d='m13.224 4.054 9.498 5.519c.37.215.37.747 0 .962l-9.498 5.519c-.584.34-1.304.34-1.887 0L1.84 10.535a.556.556 0 0 1 0-.962l9.497-5.519a1.88 1.88 0 0 1 1.887 0'
        fill='currentColor'
      />
      <path
        d='m22.719 10.54-3.227 1.874-6.265 3.64a1.9 1.9 0 0 1-1.891 0l-6.266-3.64-3.234-1.875a.564.564 0 0 1 0-.969l9.5-5.515a1.9 1.9 0 0 1 1.89 0L22.72 9.57a.558.558 0 0 1 0 .97'
        fill='currentColor'
      />
      <path
        d='M13.816 17.068c-.472.27-1 .41-1.535.41a3.1 3.1 0 0 1-1.528-.406L5.07 13.77v2.933c0 .656.344 1.258.914 1.586l3.961 2.29a4.69 4.69 0 0 0 4.664 0l3.97-2.29c.562-.328.913-.93.913-1.586V13.77zm9.074.672v-5.945l-1.407.817v5.127a1.251 1.251 0 1 0 1.407 0'
        fill='currentColor'
      />
    </svg>
  )
}
